<section class="categories-section">
<h2 class="section-title">{{ pageTexts.CATEGORIES_TITLE }}</h2>
  <div class="carousel-wrapper">
    <div class="swiper categories-swiper" #swiperEl>
      <div class="swiper-wrapper">
        @for (category of categories; track category.id) {
          <div class="swiper-slide">
            <article class="category-card">
              <div class="card-image-wrapper">
                <img [src]="category.imageUrl" [alt]="category.name" loading="lazy" decoding="async">
              </div>
              <h3 class="category-name">{{ category.name }}</h3>
            </article>
          </div>
        } </div>
      <div class="swiper-button-prev custom-nav"></div>
      <div class="swiper-button-next custom-nav"></div>
      <div class="swiper-pagination custom-pagination"></div>
    </div>
  </div>
</section>
